var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!_vm.newUi)?_c('ChartDashboard'):_vm._e(),(_vm.newUi)?_c('Insights'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }